import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of, Subject } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { EmployeesService } from '../../../services/employees/employees.service';

@Component({
  selector: 'unico-people-employee-contractual-infos',
  templateUrl: './employee-contractual-infos.component.html',
  styleUrls: ['./employee-contractual-infos.component.scss']
})
export class EmployeeContractualInfosComponent implements OnInit {
  infos$: Observable<any>;
  error$ = new Subject<any>();

  acc: string;
  uuid: string;
  colabId: string;
  error = false;
  bondTypeLabel: any;
  vinculos: any;
  position: any;

  limitDate: any;

  isColaboratorModule = true;

  constructor(private activatedRoute: ActivatedRoute, private employeesService: EmployeesService) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.uuid = params.p;
    });
    this.loadCollaboratorInfo();
  }

  editCallback(): void {
    this.infos$ = of('');
    this.loadCollaboratorInfo();
  }

  loadCollaboratorInfo() {
    this.infos$ = this.employeesService.getEmployee(this.uuid).pipe(
      map(res => res.data),
      catchError(err => of(err))
    );
  }
}
